import moment from 'moment';
import { AFSP } from 'utils/reqUtils';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
PREFIX = '/home',
{ setEnvPrefix, getDataType } = ssCommonUtils;

export const WINDOW = {
    DESKTOP_MENU: 'desktop',
    MOBILE_MENU: 'mobile'
}

// Automatically prefixes the path with the portal PREFIX and sets the environment
// prefix instead of requireing that they be manually added to each path.
export const ROUTES = (c => {
    const prefixValues = o => {
        for(let i in o)
            switch(getDataType(o[i])) {
                case 'String': o[i] = setEnvPrefix(`${PREFIX}${o[i]}`); break;
                case 'Object': o[i] = prefixValues(o[i]); break;
            }
        return o;
    }
    for(let p in c)
        switch(getDataType(c[p])) {
            case 'String': c[p] = setEnvPrefix(`${PREFIX}${c[p]}`); break;
            case 'Object': c[p] = prefixValues(c[p]); break;
        }
    return c;
})({
    ROOT: '',
    HOME: {
        PRA: `/paperworkreductionact`,
        PAS: `/privacyactstatement`,
        CANDIDATE_REGISTRATION: `/candidateregistration`,
        CANDIDATE_RECOVERY: `/candidaterecovery`,
        PROVIDER_REGISTRATION: `/providerregistration`,
        RESET_PASSWORD: `/passwordreset`,
        RESET_ACCOUNT_REQUEST: `/resetAccountRequest`,
        RESET_EXPIRED_PASSWORD: `/passwordexpirationreset`,
        CHANGE_EMAIL: `/changeemail`,
        DOD_REGISTRATION: `/dodregistration`,
        REACTIVATE_USER: `/reactivateUser`,
        HELP: `/help`
    },
    LOGIN: {
        CHANGE_EMAIL: `/login/changeemail`
    },
    PAYMENT: {
        CONFIRM: `/payment*`
    }
})

// Pass it an two args. First, an array of strings that is the name of the functions you
// want to pull out of the services. Second, the services/actions object that is being
// used. The result is an object that contains only those functions you want.
export function getServices(services, list) {
    var result = {};
    for (var i = 0; i < list.length; i++) {
        for (var s in services) {
            if(list[i] === s) {
                result[ s ] = services[ s ]
                break;
            }
        }
    }
    return result;
}

export function metricMinusPercent(metric, percent) {
    return Math.round(metric - (metric * percent));
}

// xfsb stands for 'x form string builder'. Builds a string using an object with the
// 'application/x-www-form-urlencoded' header format. Each property of the object is
// used as the 'key' of the string and each value of each property is used as the
// 'value' for the 'key'.
//
// [DOC] <string> xfsb({ <property>:<value>, <property>:<value>, ... });
//
// [FUNCTION] xfsb({ firstName: 'John', lastName: 'Doe' });
//
// [RETURNS] 'firstName=John&lastName=Doe'
export function xfsb(obj) {
    var str = '';
    for (var p in obj)
        str += p + '=' + obj[p] + '&';
    return str.substring(0, str.length - 1);
}

export function formRedirect(path, params, method) {
    method = method || "post";

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params)
        if(params.hasOwnProperty(key)) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);

            form.appendChild(hiddenField);
        }

    document.body.appendChild(form);
    form.submit();
}

export const UNBOUND_REQUEST_TYPES = {
    EMAIL_CHECK: 'EMAIL_CHECK',
    USER_ID_CHECK: 'USER_ID_CHECK'
};

export function unboundRequest(type, data, service) {
    var
    xhr,
    url,
    data,
    method,
    callback,
    mediaType,
    requestObjects = {
        check: {
            requestData: {
                timestamp: null,
                originatingSystem: AFSP.ORIGINATING_SYSTEM,
                messageUuid: 'e60299b0-e039-4a05-bb58-ea49e6795b81',
                checkType: null,
                checkValue: null
            },
            callback: () => {
                const { readyState, status } = xhr;
                if(readyState == XMLHttpRequest.DONE) {
                    switch (status) {
                        case 200:
                            service(-1);
                            break;
                        case 404:
                            service(1);
                            break;
                    }
                }
            }
        }
    };

    if(xhr == null) xhr = new XMLHttpRequest();

    switch(type) {
        case UNBOUND_REQUEST_TYPES.EMAIL_CHECK:
            callback = requestObjects.check.callback;
            method = 'POST';
            mediaType = 'json';
            url =  setEnvPrefix(AFSP.ENDPOINTS.USER_CHECK);
            data = {...requestObjects.check.requestData,
                timestamp: moment().unix(),
                checkType: AFSP.CHECK_TYPE.EMAIL,
                checkValue: data
            };
            break;
        case UNBOUND_REQUEST_TYPES.USER_ID_CHECK:
            callback = requestObjects.check.callback;
            method = 'POST';
            url = setEnvPrefix(AFSP.ENDPOINTS.USER_CHECK);
            mediaType = 'json';
            data = {...requestObjects.check.requestData,
                timestamp: moment().unix(),
                checkType: AFSP.CHECK_TYPE.USERNAME,
                checkValue: data
            };
            break;
    }

    xhr.onreadystatechange = callback;
    xhr.open(method, url, true);

    switch(mediaType) {
        case 'json':
            xhr.setRequestHeader('Content-Type', 'application/json');
            break;
    }

    if(data == null) xhr.send();
    else xhr.send(JSON.stringify(data));
}

export function grouped(lookups, group) {
    return lookups
        .filter((lookup) => lookup.groups.includes(group))
        .filter((value, index, self) =>
            // Remove duplicates
            index === self.findIndex((t) => t.value === value.value));
}
